import { create } from 'zustand';

/** Antwortteil des Backends, wenn eine Kunden-Mail geändert wurde und Termine bevorstehen. */
export interface MitMailRueckfrage {
  mail_rueckfrage?: { kennung: string; termine: number };
}

interface KundenMailRueckfrageState {
  kennung: string | null;
  fragen: (kennung: string) => void;
  schliessen: () => void;
}

/**
 * Offene Rückfrage nach geänderter Kunden-Mail (Decision #254, Planänderung B).
 * Eine neue Änderung ersetzt die offene Frage: gesendet wird nur an die letzte Adresse.
 */
const useKundenMailRueckfrageStore = create<KundenMailRueckfrageState>((set) => ({
  kennung: null,
  fragen: (kennung) => set({ kennung }),
  schliessen: () => set({ kennung: null }),
}));

export default useKundenMailRueckfrageStore;
